import React from 'react';

import Flex from '@waglabs/flex';

import LoadingBoneSpinner from '../LoadingBoneSpinner/LoadingBoneSpinner';

/**
 * @deprecated Use the <LoadingBone /> from the components
 */
const LoadingBoneModal = (props: {}) => (
  <Flex
    position="fixed"
    top="0"
    left="0"
    bottom="0"
    right="0"
    justifyContent="center"
    alignItems="center"
    zIndex="10"
    {...props}
  >
    <LoadingBoneSpinner />
  </Flex>
);

export default LoadingBoneModal;
